import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useHistory, useParams, generatePath,  } from 'react-router';
import TicketList from '../Liff/TicketList';
import TicketPaidList from '../Liff/TicketPaidList';
import LiffTicket from '../Liff/Ticket';
import moment from 'moment';
import Select from 'react-select';
import Modal from 'react-modal';
import Encoding from 'encoding-japanese';
import Papa from "papaparse";

const Coupon = (props) => {
  const { user, setting } = props;
  const { siteId, mallId } = useParams();
  const [ticketData, setTicketData] = useState(null);
  const [shopGroupMaster, setShopGroupMaster] = useState([]);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const [importDisplayData, setImportDisplayData] = useState(null);
  const [importData, setImportData] = useState(null);
  const [errMessage, setErrMessage] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [selectData, setSelectData] = useState(null);
  const [name, setName] = useState({
    ticket_id: '',
    ticket_name: '',
  });
  const history = useHistory();

  const [values, setValues] = useState({
    ticket_id: null,
    ticket_name: '',
    ticket_summary: '',
    ticket_detail: '',
    ticket_image_url: '',
    ticket_notes: '',
    ticket_start_date: moment().format('YYYYMMDD'),
    ticket_end_date: moment().format('YYYYMMDD'),
    ticket_times: 1,
    use_point: 0,
    amount_mall: 0,
    amount_shop: 0,
    ticket_type: constClass.TICKET_TYPE.FREE,
    limit_issue_flag: constClass.FLAG.OFF,
    sales_ticket_code: '',
    uploadfile: null,
    uploadfiletype: null,
    deletefile: null
  });

  const [searchData, setSearchData] = useState({
    ticket_type: '',
  });

  const [shopGroupON, setShopGroupONValues] = useState([]);
  const [shopGroupOFF, setShopGroupOFFValues] = useState([]);

  const modalConfirmStyle = {
    overlay: {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: "rgba(0,0,0,0.5)"
    },
    content: {
      left: '10%',
      right: '10%',
      top: '15%',
      bottom: 'auto',
      padding: "0px",
      maxHeight: "80%",
      width: "80%",
      overflowX: "hidden",
      pointerEvents: "auto",
      backgroundClip: "padding-box",
      border: "1px rgba(0,0,0,.2)",
      overflow: "visible",
    }
  };

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    var ticketData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    searchData.ticket_type && (ticketData = ticketData.filter(t => Number(t.ticket_type) === Number(searchData.ticket_type)));
    setTicketData(ticketData);
    const shopGroup = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data.map((val) => { return { value: val.shop_group_id, label: val.shop_group_name }; });
    setShopGroupMaster(shopGroup);
  }, [siteId, mallId, searchData]);

  /* コピーボタン押下 */
  const handleCopyClick = (data) => {
    const temp = { ...data };
    temp.ticket_id = null;
    temp.limit_issue_flag = constClass.FLAG.OFF;
    temp.deletefile = null;
    temp.uploadfiletype = null;
    if (data.ticket_image_url != null) temp.uploadfile = `/${siteId}/${constClass.TICKET_IMAGE_DIR + data.ticket_image_url}`;
    else temp.uploadfile = null;
    temp.ticket_summary = temp.ticket_summary ? temp.ticket_summary : '';
    temp.ticket_detail = temp.ticket_detail ? temp.ticket_detail : '';
    temp.app_url = temp.app_url ? temp.app_url : '';
    temp.app_text = temp.app_text ? temp.app_text : '';
    temp.detail_url = temp.detail_url ? temp.detail_url : '';
    temp.detail_text = temp.detail_text ? temp.detail_text : '';
    const shopGroupONValues = data.shop_group
      .filter(a => a.use_flg === constClass.FLAG.ON)
      .map(a => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value === a.shop_group_id).label }));

    const shopGroupOFFValues = data.shop_group
      .filter(a => a.use_flg === constClass.FLAG.OFF)
      .map(a => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value === a.shop_group_id).label }));

    if (shopGroupONValues.length > 0) {
      setShopGroupONValues(shopGroupONValues);
    } else if (shopGroupOFFValues.length > 0) {
      setShopGroupOFFValues(shopGroupOFFValues);
    }
    setValues(temp);
  }

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;
    temp.deletefile = null;
    temp.uploadfiletype = null;
    if (data.ticket_image_url != null) temp.uploadfile = `/${siteId}/${constClass.TICKET_IMAGE_DIR + data.ticket_image_url}`;
    else temp.uploadfile = null;
    temp.ticket_summary = temp.ticket_summary ? temp.ticket_summary : '';
    temp.ticket_detail = temp.ticket_detail ? temp.ticket_detail : '';
    temp.app_url = temp.app_url ? temp.app_url : '';
    temp.app_text = temp.app_text ? temp.app_text : '';
    temp.detail_url = temp.detail_url ? temp.detail_url : '';
    temp.detail_text = temp.detail_text ? temp.detail_text : '';
    const shopGroupONValues = data.shop_group
      .filter(a => a.use_flg === constClass.FLAG.ON)
      .map(a => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value === a.shop_group_id).label }));

    const shopGroupOFFValues = data.shop_group
      .filter(a => a.use_flg === constClass.FLAG.OFF)
      .map(a => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value === a.shop_group_id).label }));

    if (shopGroupONValues.length > 0) {
      setShopGroupONValues(shopGroupONValues);
    } else if (shopGroupOFFValues.length > 0) {
      setShopGroupOFFValues(shopGroupOFFValues);
    }
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      ticket_id: null,
      ticket_name: '',
      ticket_summary: '',
      ticket_detail: '',
      ticket_image_url: '',
      ticket_notes: '',
      hp_url: '',
      ticket_start_month: moment().format('YYYYMM'),
      ticket_end_month: '999912',
      ticket_times: 1,
      uploadfile: null,
      uploadfiletype: null,
      deletefile: null,
      ticket_start_date: moment().format('YYYYMMDD'),
      ticket_end_date: moment().format('YYYYMMDD'),
      use_point: 0,
      amount_mall: 0,
      amount_shop: 0,
      limit_issue_flag: constClass.FLAG.OFF,
      ticket_type: constClass.TICKET_TYPE.FREE,
      sales_ticket_code: '',
    });
    setShopGroupONValues([]);
    setShopGroupOFFValues([]);
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (data.ticket_type === constClass.TICKET_TYPE.FREE) {
      data.use_point = 0;
    }
    if (data.ticket_type === constClass.TICKET_TYPE.PAID) {
      data.amount_mall = 0;
      data.amount_shop = 0;
    }
    if (!data.ticket_name) {
      window.alert('クーポン名を入力してください。');
      return;
    }
    if (data.ticket_name.length > 50) {
      window.alert('クーポン名は、50文字以内で入力してください。');
      return;
    }
    if (!data.ticket_summary) {
      window.alert('クーポン概要を入力してください。');
      return;
    }
    if (data.ticket_summary.length > 200) {
      window.alert('クーポン概要は、200文字以内で入力してください。');
      return;
    }
    if (data.ticket_detail && data.ticket_detail.length > 200) {
      window.alert('クーポン詳細は、200文字以内で入力してください。');
      return;
    }
    if (data.ticket_notes && data.ticket_notes.length > 1000) {
      window.alert('注意事項は、1000文字以内で入力してください。');
      return;
    }
    if (!data.ticket_start_date) {
      window.alert('利用開始日を入力してください。');
      return;
    }
    if (!data.ticket_end_date) {
      window.alert('利用終了日を入力してください。');
      return;
    }
    if (!String(data.amount_mall)) {
      window.alert('負担額（施設）を入力してください。');
      return;
    }
    if (!(String(data.amount_mall)).match(/^[0-9]+$/)) {
      window.alert('負担額（施設）は正の半角整数で入力してください。');
      return;
    }
    if (!String(data.amount_shop)) {
      window.alert('負担額（店舗）を入力してください。');
      return;
    }
    if (!(String(data.amount_shop)).match(/^[0-9]+$/)) {
      window.alert('負担額（店舗）は正の半角整数で入力してください。');
      return;
    }
    if (!String(data.ticket_times)) {
      window.alert('利用可能回数を入力してください。');
      return;
    }
    if (!(String(data.ticket_times)).match(/^[0-9]+$/)) {
      window.alert('利用可能回数は正の半角整数で入力してください。');
      return;
    }
    if (!String(data.use_point)) {
      window.alert('利用ポイント数を入力してください。');
      return;
    }
    if (!(String(data.use_point)).match(/^[0-9]+$/)) {
      window.alert('利用ポイント数は正の半角整数で入力してください。');
      return;
    }
    if (data.sales_ticket_code && data.sales_ticket_code.length > 20) {
      window.alert('売上管理クーポンコードは、20文字以内で入力してください。');
      return;
    }
    if (!data.sales_ticket_code && Number(data.amount_mall) > 0 && data.ticket_type === constClass.TICKET_TYPE.FREE) {
      window.alert('売上管理クーポンコードを入力してください。');
      return;
    }
    if (data.ticket_times === "") {
      data.ticket_times = 0;
    }
    var params = data;
    if (data.uploadfiletype === null) data.uploadfile = null;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;
    params.shop_group = null;

    if (shopGroupON.length > 0) {
      params.shop_group = shopGroupON.map(shop => ({ site_id: siteId, shop_group_id: shop.value, use_flg: constClass.FLAG.ON }));
    } else if (shopGroupOFF.length > 0) {
      params.shop_group = shopGroupOFF.map(shop => ({ site_id: siteId, shop_group_id: shop.value, use_flg: constClass.FLAG.OFF }));
    }

    let res;
    try {
      setLockData(true);
      if (params.ticket_id === null || params.ticket_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/ticket/${params.ticket_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`クーポン[${data.ticket_id}:${data.ticket_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      ticket_id: data.ticket_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

   // ファイルdata
   const handleFile = async (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      const codes = new Uint8Array(reader.result);
      const encoding = Encoding.detect(codes);
      const csv = Encoding.convert(codes, {
        to: 'UNICODE',
        from: encoding,
        type: 'string',
      });
      var List = []; // 登録データ
      var ErrBox = []; // エラーデータ
      var check = null; // チェックデータ
      var errflag = false; // エラーフラグ
      var dataflag = false; // データフラグ
      var filename = value.name; //ファイル名

      if (filename.slice(filename.lastIndexOf('.') + 1) !== "csv" && filename.slice(filename.lastIndexOf('.') + 1) !== "txt") {
        window.alert("csv形式のファイルをアップロードしてください");
        return;
      }

      const imp = Papa.parse(csv, { skipEmptyLines: true }).data;
      if (['line_id', 'lineid', 'Line_id', 'line_Id', 'LINE_ID', 'Line_Id'].includes(imp[0][0])) {
        imp.shift(); // １行目を削除
      }

      try {
        imp.forEach((row, rowIdx) => {
          check = {
            "line_id": row[0].replace(/"/g, '').trim(),
            "ticket_id": name.ticket_id,
          };

          // データチェック
          if (!check.line_id) {
            errflag = true;
            ErrBox.push(rowIdx + 1 + '行目：LINEIDを入力してください');
          }
          dataflag = true;
          if (errflag === false) {
            List.push(check);
          }
        });
      } catch {
        window.alert("ファイルのデータ内容が不正です");
        return;
      }

      // エラーメッセージ
      if (dataflag === false) {
        ErrBox.push("取り込むデータがありません");
        window.alert("取り込むデータがありません");
      }
      if (errflag === true) {
        window.alert("取込エラー");
      }

      setImportDisplayData(imp);
      setImportData(List);
      setErrMessage(ErrBox);
    }
    reader.readAsArrayBuffer(value);
  }

  // CSVデータインポート
  const clearImportData = () => {
    setImportDisplayData(null);
    setImportData(null);
    setErrMessage(null);
    setConfirm(false);
  }

  // CSV戻るボタン
  const handleBackClick = () => {
    setImportDisplayData(null);
    setImportData(null);
    setErrMessage(null);
  }

  // CSVデータ反映：処理
  const handleExecClick = async () => {
    const jwt = localStorage.getItem('jwt');

    let res;
    setLockData(true);
    var import_data = [];

    try {
      const ticketIdData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/csv/info/${siteId}/${name.ticket_id}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      importData.forEach((data) => {
        var add_data = {
          site_id: siteId,
          ticket_id: data.ticket_id,
          line_id: data.line_id,
          limit_date: ticketIdData.ticket_end_date,
          ins_name: user.userId,
          upd_name: user.userId,
        };
        import_data.push(add_data);
      });
    } catch (err) {
      console.log(err);
    }

    try {
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/import/${siteId}`, import_data, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      });
    } catch (err) {
      console.log(err);
      if (err.response.data) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.message, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      console.log(res);
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        setErrMessage(res.data.box);
        clearImportData();
        setConfirm(false);
        await refreshData();
      }
      setLockData(false);
      //userActions.logout();
    }
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderCopyButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleCopyClick(data)}>
        コピー
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.ticket_name === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.ticket_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const renderAutomaticDistributionButton = (data) => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1`}
        onClick={() => history.push(`${generatePath(`${props.match.path}`, { siteId, mallId })}coupon/${data.ticket_id}`)}>
        自動配信
      </button>
    )
  }

  const renderCSVUploadButton = (data) => {
    const setCsvUpload = () => {
      setConfirm(true);
      setName({
        ...name,
        ticket_id: data.ticket_id,
        ticket_name: data.ticket_name,
      });
    };
    return (
      <button type="button"
        disabled={lockData || data.ticket_id === null || data.ticket_name === null}
        className={`btn btn-primary mx-1 w-60`}
        onClick={setCsvUpload}>
        CSVアップロード
      </button>
    )
  }


  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleSearchChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setSearchData({ ...searchData, [name]: value });
  }

  const handleChangeShopGroupOFF = (data) => {
    setShopGroupOFFValues(data);
  }

  const handleChangeShopGroupON = (data) => {
    setShopGroupONValues(data);
  }

  const handleChangeFile = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setValues({
        ...values,
        uploadfile: reader.result,
        uploadfiletype: value.type,
        deletefile: values.ticket_image_url
      });
    }
    reader.readAsDataURL(value);
  }

  const handleDeleteFile = () => {
    setValues({ ...values, uploadfile: null, uploadfiletype: null, deletefile: values.ticket_image_url });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>クーポンID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="ticket_id" defaultValue={values.ticket_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>クーポン名</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="ticket_name" value={values.ticket_name} onChange={handleChange} placeholder="クーポン名を入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ticket_summary">クーポン概要</label>
          </div>
          <div className="col-5 align-self-center">
            <input type="text" className="form-control" name="ticket_summary" id="ticket_summary" value={values.ticket_summary} placeholder="クーポンの概要を入力してください" onChange={handleChange}></input>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ticket_detail">クーポン詳細</label>
          </div>
          <div className="col-5 align-self-center">
            <textarea className="form-control" rows="3" name="ticket_detail" id="ticket_detail" value={values.ticket_detail} onChange={handleChange}></textarea>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="remarks">クーポン画像</label>
          </div>
          <div className="col-5 align-self-center">
            {!(values.uploadfile) && <input type="file" className="form-control-file" name="ticketImage" id="ticketImage" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
            {values.uploadfile && <object id="uploadfileview" className="w-100" data={values.uploadfile} type={values.uploadfiletype}><img className="w-100" src={values.uploadfile} alt='uploadfile' /></object>}
            {values.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ticket_notes">注意事項</label>
          </div>
          <div className="col-5 align-self-center">
            <textarea className="form-control" rows="3" name="ticket_notes" id="ticket_notes" value={values.ticket_notes} onChange={handleChange}></textarea>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ticket_start_date">利用開始日</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="ticket_start_date" value={values.ticket_start_date.replace(/-/g, "")} onChange={handleChange} placeholder="YYYYMMDD" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ticket_end_date">利用終了日</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="ticket_end_date" value={values.ticket_end_date.replace(/-/g, "")} onChange={handleChange} placeholder="YYYYMMDD" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ticket_type">クーポン区分</label>
          </div>
          <div className="col-3">
            <select className="form-control" id="ticket_type" name="ticket_type" value={values.ticket_type} onChange={handleChange}>
              <option key={constClass.TICKET_TYPE_NAME.FREE} value={constClass.TICKET_TYPE.FREE}>{constClass.TICKET_TYPE_NAME.FREE}</option>
              <option key={constClass.TICKET_TYPE_NAME.PAID} value={constClass.TICKET_TYPE.PAID}>{constClass.TICKET_TYPE_NAME.PAID}</option>
            </select>
          </div>
        </div>
        {values.ticket_type === constClass.TICKET_TYPE.PAID &&
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="use_point">利用ポイント数</label>
            </div>
            <div className="col-5 align-self-center">
              <input type="text" className="form-control" name="use_point" value={values.use_point} onChange={handleChange} placeholder="クーポン利用時にポイントを消費する場合のポイント数" />
            </div>
          </div>
        }
        {values.ticket_type === constClass.TICKET_TYPE.FREE &&
          <React.Fragment>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="amount_mall">負担額（施設）</label>
              </div>
              <div className="col-5 align-self-center">
                <input type="text" className="form-control" name="amount_mall" value={values.amount_mall} onChange={handleChange} />
              </div>
            </div><div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="amount_shop">負担額（店舗）</label>
              </div>
              <div className="col-5 align-self-center">
                <input type="text" className="form-control" name="amount_shop" value={values.amount_shop} onChange={handleChange} />
              </div>
            </div>
          </React.Fragment>
        }
        {shopGroupON.length === 0 &&
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="use_flg">利用不可店舗グループ</label>
            </div>
            <div className="col-5 align-self-center">
              <Select options={shopGroupMaster} isMulti closeMenuOnSelect={false} value={shopGroupOFF} onChange={handleChangeShopGroupOFF} placeholder="クーポンを利用できない店舗グループ" />
            </div>
          </div>
        }
        {shopGroupOFF.length === 0 &&
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="use_flg">利用可能店舗グループ</label>
            </div>
            <div className="col-5 text-center align-self-center">
              <Select options={shopGroupMaster} isMulti closeMenuOnSelect={false} value={shopGroupON} onChange={handleChangeShopGroupON} placeholder="クーポンを利用できる店舗グループ" />
            </div>
          </div>
        }
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="limit_issue_flag">限定発行フラグ</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="checkbox" className="form-control w-25" name="limit_issue_flag" value="true" checked={values.limit_issue_flag === constClass.FLAG.ON} onChange={handleChange}></input>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ticket_times">利用可能回数</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="ticket_times" value={values.ticket_times} onChange={handleChange} placeholder="クーポンを利用できる回数" />
          </div>
          <div className="col-5 text-left align-self-center">
            無制限に利用可能とする場合は「0」を入力してください
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="sales_ticket_code">売上管理クーポンコード</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="sales_ticket_code" value={values.sales_ticket_code} onChange={handleChange} placeholder="売上管理システムに連携する場合のクーポンコード" />
          </div>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderResetButton(values)}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    return (
      <div className="row mb-3 p-0 mt-2">
        <div className="mr-1 text-center align-self-center">
          <span>クーポン区分</span>
        </div>
        <div className="col-12 mb-2">
          <div className="row">
            <select className="col-2 custom-select w-100 text-left" aria-label="クーポン区分" name="ticket_type" value={searchData.ticket_type || ''} onChange={handleSearchChange}>
              <option value="">選択してください</option>
              <option key={constClass.TICKET_TYPE_NAME.FREE} value={constClass.TICKET_TYPE.FREE}>{constClass.TICKET_TYPE_NAME.FREE}</option>
              <option key={constClass.TICKET_TYPE_NAME.PAID} value={constClass.TICKET_TYPE.PAID}>{constClass.TICKET_TYPE_NAME.PAID}</option>
            </select>
            <div className="col-9 text-right">
              <button type="button"
                disabled={lockData}
                className={`btn btn-primary text-right`}
                data-toggle="modal" data-target="#exampleModal"
              >
                プレビュー表示
              </button>
            </div>
          </div>
        </div>
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  クーポンID
                </td>
                <td className="text-center align-middle">
                  クーポン名
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {ticketData.map((data, idx) => (
                <tr key={data.ticket_id}>
                  {/* クーポンID */}
                  <td className="text-center align-middle">
                    {data.ticket_id}
                  </td>
                  {/* クーポン名 */}
                  <td className="text-center align-middle">
                    {data.ticket_name}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                    {renderCopyButton(data)}
                    {data.limit_issue_flag === constClass.FLAG.ON &&
                      renderCSVUploadButton(data)
                    }
                    {data.ticket_type === constClass.TICKET_TYPE.FREE && data.limit_issue_flag === constClass.FLAG.ON &&
                      renderAutomaticDistributionButton(data)
                    }
                  </td>
                </tr>
              ))
              }
              <Modal isOpen={confirm} style={modalConfirmStyle} onRequestClose={() => setConfirm(false)}>
                <div className="">
                  <div className="modal-header">
                    限定クーポンCSVインポート <br />クーポンID：{name.ticket_id}<br />クーポン名：{name.ticket_name}
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => clearImportData()}><span aria-hidden="true">&times;</span></button>
                  </div>
                  <div className="modal-body">
                    {!importDisplayData && <input type="file" className="form-control-file" name="csv" id="csv" value="" accept=".csv" onChange={handleFile} onClick={e => (e.target.value = null)} />}
                    {(importDisplayData && importDisplayData.length < 1) &&
                      <div>
                        <span>データが見つかりません。</span>
                        <button type="button" className="btn btn-secondary" onClick={() => clearImportData()}>戻る</button>
                      </div>
                    }
                    {(errMessage && errMessage.length > 0) &&
                      errMessage.map((data, dataIdx) =>
                        <div key={dataIdx} className="pl-4 text-danger">
                          <li>{data}</li>
                        </div>
                      )}
                    {(importDisplayData && importDisplayData.length > 0) &&
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col table-responsive">
                            <table className="table table-sm table-bordered">
                              <thead>
                                <tr className='text-nowrap bg-gray-alpha'>
                                  <td className="text-center align-middle">
                                    LINEID
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                {importDisplayData.map((row, rowIdx) =>
                                  <tr key={rowIdx}>
                                    {row.map((data, idx) =>
                                      <td key={rowIdx + '_' + idx} className={`text-nowrap`}>{data.trim()}</td>
                                    )}
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-auto">
                            <button type="button" className="btn btn-secondary" onClick={() => handleBackClick()}>戻る</button>
                          </div>
                          <div className="col-auto">
                            <button type="button" className="btn btn-primary" disabled={(errMessage && errMessage.length > 0)} onClick={() => handleExecClick()}>{(importDisplayData.length)}件のデータを反映</button>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => (setConfirm(false))}>Close</button>
                  </div>
                </div>
              </Modal>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  const renderPreview = () => {
    return (
      <div className="modal" id="exampleModal">
        <div className="modal-dialog preview-modal">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setSelectData(null)}><span aria-hidden="true">&times;</span></button>
            </div>
            <div className="modal-body">
              {(ticketData && !selectData) &&
                <div>
                  <TicketList
                    ticket_list={ticketData.filter(ticket => ticket.ticket_type === constClass.FLAG.OFF)}
                    ticketClick={(id) => setSelectData({ ...ticketData.find(t => t.ticket_id === id), t_ticket_use: [] })}
                    siteId={siteId}
                    setting={setting}
                  />
                  <TicketPaidList
                    ticket_list={ticketData.filter(ticket => ticket.ticket_type === constClass.FLAG.ON)}
                    ticketClick={(id) => setSelectData({ ...ticketData.find(t => t.ticket_id === id), t_ticket_use: [] })}
                    siteId={siteId}
                    setting={setting}
                  />
                </div>
              }
              {selectData &&
                <LiffTicket
                  ticket={selectData}
                  ticketClick={(id) => () => { }}
                  backClick={() => setSelectData(null)}
                  disabled={lockData}
                  siteId={siteId}
                  preview={true}
                />
              }
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => setSelectData(null)}>Close</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="container">

      {ticketData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {ticketData !== null && (renderList())}
      {renderInput()}
      {renderPreview()}
    </div>
  )
}

export default Coupon;